<template>
	<button
		:class="{clickable: isClickable, toggled: toggled || disabled, disabled: disabled}"
		class="basetag"
		v-bind="$attrs"
		@click="$emit('click')"
	>
		<slot />
	</button>
</template>

<script>
export default {
	name: 'BaseTag',
	props: {
		toggled: Boolean,
		disabled: Boolean,
	},
	emits: ['click'],
	computed: {
		isClickable() {
			return this.$attrs.onClick
		},
	},
}
</script>

<style scoped>
.basetag {
	background-color: var(--gray-550);
	color: var(--gray-100);
	border-radius: var(--border-radius-md);
	padding: 3px 10px;
	font-size: 12px;
	display: flex;
	align-items: center;
	white-space: nowrap;
	border-width: 1px;
	border-color: var(--gray-550);
}

.basetag.clickable {
	cursor: pointer;
	user-select: none;
}

.basetag.toggled {
	background-color: transparent;
	color: var(--gray-400);
	border-color: var(--gray-300);
}

.dark .basetag.toggled {
	border-color: var(--gray-500);
}

.dark .basetag.toggled:hover {
	background-color: var(--gray-550);
	border-color: var(--gray-550);
}

.basetag.toggled:hover {
	background-color: var(--gray-600);
	border-color: var(--gray-600);
}

.basetag.disabled {
	pointer-events: none;
}

.basetag.disabled > :deep(svg) {
	color: var(--gray-400) !important;
	border-color: var(--gray-400) !important;
}
</style>
